<template>
  <!-- 会话列表 -->
  <ul>
    <li class="d-table w-100-p b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="item in sessions" :key="item.id"  :ref="item.id+'Ref'" v-if="item.to!=$store.state.user.loginId">
      <div class="d-table w-100-p b-b b-c-g-100 cursor-default bg-g-50-hover h-67 p-relative" v-if="(!value||(value&&(item.userInfo.name&&item.userInfo.name.includes(value)||(item.userInfo.userName&&item.userInfo.userName.includes(value))||(item.userInfo.nickName&&item.userInfo.nickName.includes(value))||(item.userInfo.mobile&&item.userInfo.mobile.includes(value)))))">
      <div class="d-table-cell v-a-middle h-100-p w-64" v-if="item.scene==='p2p'" style="text-align: center;">
        <span v-if="item.to.length==32" class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" style="background-color: #653EB3;">{{getShortNickname((item.userInfo.nickName || item.userInfo.nick)?(item.userInfo.nickName || item.userInfo.nick):item.userInfo.mobile)}}</span>
        <img  v-else src="@/assets/images/im/kefu.svg" style="width:40px;height:40px;"/>
      </div>
      <div class="d-table-cell v-a-middle h-100-p w-64" v-if="item.scene==='team' && item.userInfo.serverCustom" style="text-align: center;">
        <img v-if="item.userInfo.avatar" :src="item.userInfo.avatar" style="width:40px;height:40px;"/>
        <img v-else src="@/assets/images/im/zhuanShu@2x.png" style="width:40px;height:40px;"/>
      </div>
      <div class="d-table-cell v-a-middle h-100-p w-64 t-a-center" v-if="item.scene==='team' && !item.userInfo.serverCustom">
        <img src="@/assets/images/im/team-cus.png" style="width:40px;height:40px;"/>
      </div>
      <div class="p-relative d-table-cell v-a-middle h-100-p">
        <div :style="{width:listWidth+'px'}">
          <!-- 单聊 -->
          <div v-if="item.scene==='p2p'">
                <p class="t-ellipsis l-h-1-6-em m-r-10" :data-type="JSON.stringify(item)" v-if="item.to.length==32">{{(item.userInfo.nickName || item.userInfo.nick)?(item.userInfo.nickName || item.userInfo.nick):item.userInfo.mobile}}</p>
                <p class="t-ellipsis l-h-1-6-em m-r-10" v-else>{{item.userInfo.userName||''}}<span v-show="item.userInfo.userName">{{item.userInfo.stationName?'-'+item.userInfo.stationName:''}}</span>
                <span v-show="!item.userInfo.userName&&!item.userInfo.stationName">{{item.userInfo.userCode}}</span></p>
                <!-- <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400">{{lastMsgCp(item)}}</p> -->
          </div>
          <!-- 群聊 -->
          <div v-if="item.scene==='team'">
                <p class="t-ellipsis l-h-1-6-em m-r-10">{{item.userInfo.name}}</p>
                <!-- <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400"><span style="color:#fb1010;" v-show="item.appointText">{{removal(item.appointText)}}</span>{{lastMsgCp(item)}}</p> -->
          </div>
          <!-- <span class="p-absolute right-6 bottom-32 p-x-5 f-s-12 l-h-1-4-em c-white" style="border-radius: 10px; background-color: #f33232;" v-if="item.unread>0">{{item.unread}}</span> -->
        </div>
      </div>
          <input class="p-absolute top-0 right-0 bottom-0 left-0 o-0 w-100-p h-100-p" name="Fruit" type="checkbox" :value="item.id" v-model="selectedSessionsID" @change="itemClickEvent(item)"/>
          <i class="d-inline-block m-t-22" v-if="selectedSessionsID.includes(item.id)">
              <img src="@/assets/images/im/selectedSession@2x.png" style="width:22px;height:22px;"/>
            </i>
            <i class="d-inline-block m-t-22" v-else>
              <img src="@/assets/images/im/unSelectedSession@2x.png" style="width:22px;height:22px;"/>
            </i>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    sessions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    width: {
      type: Number,
      default: 250
    },
  },
  data: function () {
    return {
      listWidth: 185,
      eventProxy: {
        event: null,
        currentTarget: null
      },
      groupId:'',
      selectedSessionsID: []
    };
  },
  components: {},
  mounted: function () {},
  methods: {
    // 截取名称后俩位
    getShortNickname: function (name) {
      name = name || '';
      var len = name.length;
      return name.slice(len - 2, len);
    },
    // 去重
    removal: function (data) {
      if(data){
        var arrStr = data.split(" ");
        var newArr = Array.from(new Set(arrStr));
        return newArr.join(" ");
      }
    },
    // 点击联系人
    itemClickEvent: function (item) {
      console.log('createSession',item);
      if(this.selectedSessionsID.includes(item.id)){
        this.$emit('createSession', item);
      }else{
        this.$emit('delSelectedSession', {
          delItem: item,
          keyName: "id"
        });
      }
      this.bus.$emit("selectNewsTab");
    },
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
    },
    "$attrs.reverseDelSession"(newVal){
      if(Object.keys(newVal).length > 0){
        //点击右侧的删除，反向删除左侧选中的列表
        let index = this.selectedSessionsID.findIndex(item=>{
          return item == newVal.id
        })
        this.$delete(this.selectedSessionsID,index);
      }
    },
    "$attrs.visible"(newVal){
      if(!newVal){
        this.selectedSessionsID = [];
      }
    },
  },
  computed: {
    // 动态设置最后一条消息
    lastMsgCp: function () {
      return function (item) {
        // console.log("item",item);
        var len = item.chatRecordStore.length - 1;
        var lastMsg = item.chatRecordStore[len];
        if (!lastMsg || lastMsg.errorCodeExpand === 404) return '';
        if (lastMsg.type === 'text') {
          var str = lastMsg.text ? lastMsg.text : '';
          str = str.replace(/(<br>)|(&nbsp;)/g, ' ');
          str = str.replace(/<span[^>.]+>/g, ' ');
          str = str.replace(/<\/span>/g, ' ');
         
          return str;
        } if (lastMsg.type === 'image') {
          return '图片';
        }
      };
    }
  }
}
</script>
